<script lang="ts" setup>
import { computed } from 'vue'
import { useQRCode } from '@vueuse/integrations/useQRCode'
import { Icon } from '@iconify/vue2'
import { useClipboard } from '@vueuse/core'
import { ShareContentProvider } from '@/@web/modules/@shared/providers/ShareContent.provider'

const props = defineProps<{
	userId: string
	reverse?: boolean
}>()

const telegramLink = computed(
	() => `${process.env.VUE_APP_TELEGRAM_BOT_LINK}?start=id-user-risco-incendio_${props.userId}`,
)

const { copy, copied } = useClipboard({ source: telegramLink })

const qr = useQRCode(telegramLink)

function shareToWhatsapp() {
	ShareContentProvider.shareToWhatsapp(telegramLink.value)
}
</script>

<template>
	<div
		class="w-full flex flex-col items-center justify-center"
		:class="{ '!flex-col-reverse': reverse }"
	>
		<img
			class="h-[219px] w-[219px]"
			:src="qr"
			alt=""
		/>
		<div class="flex gap-2">
			<span
				class="text-blue-base flex items-center gap-2 cursor-pointer font-semibold text-sm"
				@click="shareToWhatsapp"
				>compartilhar <icon icon="gridicons:external"
			/></span>
			<span
				class="text-blue-base flex items-center gap-2 cursor-pointer font-semibold text-sm"
				@click="copy()"
				>copiar link<icon :icon="copied ? 'material-symbols:check-rounded' : 'fa7-regular:copy'"
			/></span>
		</div>
	</div>
</template>
